import type { Dispatch, SetStateAction } from 'react'
import { useHotkeys } from 'react-hotkeys-hook'
import type { Image } from '@/features/photoset/types.ts'

interface useGalleryInitialQaShortcuts {
	images: Omit<Image, 'space'>[]
	currentDetailImageIndex: number
	setCurrentDetailImageIndex: Dispatch<SetStateAction<number | null>>
	onClose: () => void
}

export const useGalleryInitialQaShortcuts = (
	args: useGalleryInitialQaShortcuts
) => {
	const {
		currentDetailImageIndex,
		setCurrentDetailImageIndex,
		images,
		onClose
	} = args
	useHotkeys(
		'ArrowLeft',
		() => {
			setCurrentDetailImageIndex(currentDetailImageIndex - 1)
		},
		{ enabled: currentDetailImageIndex >= 1 },
		[currentDetailImageIndex]
	)

	useHotkeys(
		'ArrowRight',
		() => {
			setCurrentDetailImageIndex(currentDetailImageIndex + 1)
		},
		{ enabled: currentDetailImageIndex < images.length - 1 },
		[currentDetailImageIndex]
	)

	useHotkeys('Esc', onClose)
}
